/**
 * @deprecated Read url from GraphQL server. Missing transformations should be added to the GraphQL server.
 */
export const getCloudinaryImageUrl = (
  baseUrl: string,
  cloudinaryId?: string | null,
  cropping?: {
    height: number;
    width: number;
    x?: number;
    y?: number;
  } | null,
  type?: 'CONTACT_PERSON' | 'LOGOTYPE' | 'INLINE_IN_BODY' | 'COVER_IMAGE',
  gravity?: { x: number; y: number } | null,
) => {
  // some cloudinary ids may contain a . and these ones will lead to broken urls
  if (!cloudinaryId || cloudinaryId.indexOf('.') > -1) return;

  let imageTransformation = '';

  let imageCropping = '';
  switch (type) {
    case 'CONTACT_PERSON':
      imageTransformation = '/c_fill,dpr_auto,f_auto,g_auto,h_250,q_auto:good,w_250';
      break;
    case 'LOGOTYPE':
      imageTransformation = '/c_limit,dpr_auto,f_auto,q_auto:good,w_600';
      break;
    case 'INLINE_IN_BODY':
      imageTransformation = '/f_auto,t_limit_1000';
      break;
    case 'COVER_IMAGE':
      imageTransformation = `/ar_16:9,c_fill,dpr_auto,f_auto,g_xy_center,q_auto:good,w_746,x_${gravity?.x},y_${gravity?.y}`;
      break;
    default:
      imageTransformation = '/dpr_auto,f_auto,q_auto:good';
      break;
  }
  if (cropping) {
    imageCropping = `/c_crop,h_${cropping.height},w_${cropping.width},x_${cropping.x},y_${cropping.y}`;
  }

  return `https://${baseUrl}/image/upload${imageCropping}${imageTransformation}/${cloudinaryId}`;
};
